export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const lastRoute = ref(router.currentRoute.value);

  router.afterEach((to, from) => {
    if (to.name !== from.name) {
      lastRoute.value = from;
    }
  });

  return {
    provide: {
      lastRoute,
    },
  };
});
